import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViMessageComponent {
  @Input() clickable: boolean;
  @Input() type: 'info' | 'warning' | 'success' | 'error';
}
